// extracted by mini-css-extract-plugin
module.exports = {"hidden":"_3y_VY","visible":"_24boS","collapsed":"yv36L"};